import { TABLA_CAMIONES_PENALIZADOS } from '../../../../../../config/tables'
import { COLUMNS_CAMIONES_PENALIZADOS, COLUMNS_CAMIONES_PENALIZADOS_TO_PRINT } from './constantesCamionesPenalizados'
import { TablaCamionesPenalizadosService } from '../servicio/tabla_camiones_penalizados'
import { pdfCustomToolbarGenerator } from '../../../../../../models/tools/generarPdf'
import CamionesPenalizados from '../../../../../../models/camiones/camiones_penalizados'
import CpaEnPlaya from '../../../../../../models/camiones/cpa_en_playa'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CAMIONES_PENALIZADOS
    })
    TablaCamionesPenalizadosService.getCamionesPenalizados().then(callback)
    function callback (result) {
      const data = []
      result.forEach(d => { data.push({ ...d, cartadeporte: d.numero }) })
      const customToolbar = pdfCustomToolbarGenerator(
        'Camiones penalizados',
        data,
        COLUMNS_CAMIONES_PENALIZADOS_TO_PRINT,
        'landscape')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_CAMIONES_PENALIZADOS,
          data: data,
          title: `Camiones penalizados`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            print: false,
            pagination: false,
            tableBodyMaxHeight: '450px'
          }
        },
        id: TABLA_CAMIONES_PENALIZADOS
      })
    }
  }
}

export function deletePenalizacion (patente, vencimiento) {
  return dispatch => {
    CamionesPenalizados.deletePenalizacionVigente(patente, vencimiento)
      .then(async (saveStatus) => {
        dispatch({ type: 'DELETE_PENALIZACION_PATENTE', saveStatus })
        if (!saveStatus.error) {
          dispatch(actualizarDatosParaMuiTable())
        }
      })
  }
}

export function buscarDatosPatente (patente) {
  return dispatch => {
    CamionesPenalizados.getPenalizacionPorPatente(patente)
      .then((resultado) => {
        const patente = resultado.patente
        const motivo = resultado.motivo
        const vencimiento = resultado.fechaVencimiento
        dispatch({ type: 'TRANSPORTE_TERRESTRE_PENALIZADO', patente, motivo, vencimiento })
      })
  }
}

export function buscarPatenteEnPlaya (patente) {
  return dispatch => {
    CpaEnPlaya.getByCamion(patente)
      .then((camion) => {
        const numeroPenalizado = camion.numero
        dispatch({ type: 'CAMION_PENALIZADO_EN_PLAYA', numeroPenalizado })
      })
  }
}
